import { useCallback, useState } from 'react';
import type { ViewportHeightRequest } from '../types/viewport-height-request.types';

/**
 * Coordinates minimum viewport heights without letting one owner clear another.
 * @returns The active minimum and a stable request/release function for context.
 */
export const useViewportHeightBoundary = () => {
  const [requests, setRequests] = useState<Record<string, number>>({});
  const requestHeight = useCallback<ViewportHeightRequest>((owner, height) => {
    setRequests((previous) => {
      if (previous[owner] === height) return previous;
      if (height === undefined) {
        return Object.fromEntries(
          Object.entries(previous).filter(([key]) => key !== owner)
        );
      }
      return { ...previous, [owner]: height };
    });
  }, []);
  return {
    minimumHeight: Math.max(0, ...Object.values(requests)),
    requestHeight,
  };
};
